/* override functions api.jquery.js */
Shopify.onItemAdded = function(line_item) {
  Shopify.getCart();
};

Shopify.onCartUpdate = function(cart) {
  Shopify.cartUpdateInfo(cart, '.single-cart-item-loop');
};

Shopify.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  var str;
  if (!!data.message) {
    str = data.description;
  } else {
    str = 'Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.';
  }
  jQuery('.error_message').text(str);
  jQuery('#modalAddToCartError').modal("toggle");
  setTimeout(function () {
    jQuery('.shopping__cart').removeClass("shopping__cart__on");
    jQuery('.body__overlay').removeClass("is-visible");
  }, 2000);
};

function erideMoneyFormat() {
  if (typeof Shopify !== 'undefined' && Shopify.money_format) {
    return Shopify.money_format;
  }
  if (typeof window !== 'undefined' && window.money_format) {
    return window.money_format;
  }
  return '${{amount}}';
}

function erideFormatPrice(cents) {
  return Shopify.formatMoney(cents, erideMoneyFormat());
}

function erideBuildCartLineItem(item) {
  var title = item.product_title || item.title || '';
  var variantTitle = item.variant_title;
  if (variantTitle && variantTitle !== 'Default Title') {
    title += ' — ' + variantTitle;
  }
  var image = item.image ? item.image.replace(/(\.jpg|\.png|\.webp)(\?.*)?$/i, '_90x$1$2') : '';
  if (!image && item.featured_image && item.featured_image.url) {
    image = item.featured_image.url;
  }
  return (
    '<li class="single-shopping-cart" data-line-key="' + item.key + '">' +
      '<div class="shopping-cart-img">' +
        '<a href="' + item.url + '"><img src="' + image + '" alt="" width="90" height="90" loading="lazy"></a>' +
        '<button type="button" class="eride-cart-remove" data-cart-remove="' + item.key + '" aria-label="Remove item">' +
          '<i class="icofont-close-circled"></i>' +
        '</button>' +
      '</div>' +
      '<div class="shopping-cart-title">' +
        '<h4><a href="' + item.url + '">' + title + '</a></h4>' +
        '<span class="eride-cart-line-price">' + item.quantity + ' × ' + erideFormatPrice(item.final_price || item.price) + '</span>' +
      '</div>' +
    '</li>'
  );
}

Shopify.openMiniCart = function() {
  var $cartWrap = jQuery('.cart-wrap').first();
  if (!$cartWrap.length) return;
  $cartWrap.addClass('show');
  $cartWrap.find('.shopping-cart-content').addClass('show');
};

Shopify.closeMiniCart = function() {
  jQuery('.cart-wrap').removeClass('show').find('.shopping-cart-content').removeClass('show');
};

Shopify.changeItem = function(lineKey, quantity, callback) {
  jQuery.ajax({
    type: 'POST',
    url: '/cart/change.js',
    data: { id: lineKey, quantity: quantity },
    dataType: 'json',
    success: function(cart) {
      Shopify.onCartUpdate(cart);
      if (typeof callback === 'function') callback(cart);
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  });
};

Shopify.removeItem = function(lineKeyOrVariantId) {
  if (typeof lineKeyOrVariantId === 'string' && lineKeyOrVariantId.indexOf(':') > -1) {
    Shopify.changeItem(lineKeyOrVariantId, 0);
    return;
  }
  jQuery.getJSON('/cart.js', function(cart) {
    var key = null;
    jQuery.each(cart.items, function(i, item) {
      if (String(item.variant_id) === String(lineKeyOrVariantId)) {
        key = item.key;
        return false;
      }
    });
    if (key) {
      Shopify.changeItem(key, 0);
    }
  });
};

Shopify.addItem = function(variant_id, quantity, callback) {
  quantity = quantity || 1;
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    data: 'quantity=' + quantity + '&id=' + variant_id,
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      } else {
        Shopify.cartPopap(variant_id);
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      Shopify.onError(XMLHttpRequest, textStatus);
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromForm = function(form_id, variant_id, callback) {
  var params = {
    type: 'POST',
    url: '/cart/add.js',
    beforeSend: function() {
      if (form_id == "add-item-qv") {
        jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_wait").html());
      }
    },
    data: jQuery('#' + form_id).serialize(),
    dataType: 'json',
    success: function(line_item) {
      if ((typeof callback) === 'function') {
        callback(line_item);
      } else {
        if (form_id != "add-item-qv") {
          Shopify.cartPopapForm(variant_id);
        } else {
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_added").html());
          jQuery('#' + form_id).find(".addtocartqv").addClass("added_in_cart");
          setTimeout(function() {
            jQuery('#' + form_id).find(".addtocartqv").removeClass("added_in_cart");
            jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
          }, 2000);
        }
        Shopify.onItemAdded(line_item);
      }
    },
    error: function(XMLHttpRequest, textStatus) {
      if (form_id != "add-item-qv") {
        Shopify.onError(XMLHttpRequest, textStatus);
      } else {
        jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button_error").html());
        jQuery('#' + form_id).find(".addtocartqv").addClass("error_in_cart");
        setTimeout(function() {
          jQuery('#' + form_id).find(".addtocartqv").removeClass("error_in_cart");
          jQuery('#' + form_id).find(".addtocartqv").html(jQuery(".quickViewModal_info .button").html());
        }, 2000);
      }
    }
  };
  jQuery.ajax(params);
};

Shopify.addItemFromFormStart = function(form, product_id) {
  Shopify.addItemFromForm(form, product_id);
};

Shopify.cartPopap = function(variant_id) {
  Shopify.openMiniCart();
};

Shopify.cartPopapForm = function(variant_id) {
  Shopify.openMiniCart();
};

Shopify.cartUpdateInfo = function(cart, cart_cell_id) {
  if ((typeof cart_cell_id) !== 'string') return;

  var cart_cell = jQuery(cart_cell_id);
  if (!cart_cell.length) return;

  cart_cell.empty();
  var items = cart.items || [];
  var hasItems = items.length > 0;

  if (hasItems) {
    jQuery(".single-product-cart, .item-multiple-item-count, .shopping-cart-bottom").show();
    jQuery(".cart-empty-title, .item-single-item-count").hide();
    jQuery.each(items, function(i, item) {
      if (i > 19) return false;
      jQuery(erideBuildCartLineItem(item)).appendTo(cart_cell);
    });
  } else {
    jQuery(".single-product-cart, .item-single-item-count, .shopping-cart-bottom").hide();
    jQuery(".cart-empty-title").show();
  }

  changeHtmlValue(".shopping-cart__total", erideFormatPrice(cart.total_price));
  changeHtmlValue(".shop-total", erideFormatPrice(cart.total_price));
  changeHtmlValue(".bigcounter", cart.item_count);

  if (jQuery('.currency .active').length) {
    jQuery('.currency .active').trigger('click');
  }
};

jQuery(document).on('click', '[data-cart-remove]', function(e) {
  e.preventDefault();
  e.stopPropagation();
  var key = jQuery(this).attr('data-cart-remove');
  if (key) Shopify.removeItem(key);
});

function changeHtmlValue(cell, value) {
  jQuery(cell).html(value);
}
